import { store } from '@src/state/store';
import { onPlayerIndexChanged } from '@src/state/slices/slice_game';

export default () =>
  (data: { gameId: string; playerId: string; newIndex: number }) => {
    store.dispatch(onPlayerIndexChanged(data));
  };
